var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('payment-information-form',{attrs:{"id":_vm.id},on:{"submit-new":_vm.onSubmitFromNew,"submit-edit":_vm.onSubmitFromEdit,"cancel":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }